
import { SaleLayoutConf } from "@/models/sale-layout";
import { Condition } from "@/utils/condition/condition";
import AppConditionsEdit from "@/components/models/ConditionsEdit.vue";
import Vue from "vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { SaleService } from "@/services";
import { convertIModelToConditionPropSelectGroup } from "@/utils/prop-select/convert-imodel-to-prop-select-group";
import { getModel } from "@/utils/models/model";

export default Vue.extend({
	data(){
		return {
			conditions: [] as Condition[],
			saving: false
		};
	},
	props: {
		layout: {
			type: Object as ()=>SaleLayoutConf,
			required: true
		}
	},
	computed: {
		saleMapPropSelectGroup():PropSelectGroup{
			return convertIModelToConditionPropSelectGroup(getModel("Sale"));
		}
	},
	watch: {
		layout: {
			immediate: true,
			handler(){
				this.conditions = this.layout.Conditions;
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			if (this.saving) return;
			this.saving = true;
			try{
				let layout = new SaleLayoutConf(this.layout.getJSON());
				layout.Conditions = this.conditions;
				await SaleService.putSaleLayouts([layout]);
				this.layout.Conditions = this.conditions;
				this.close();
			}catch(err){

			}
			this.saving = false;
		}
	},
	components: {
		AppConditionsEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
